import React from 'react';
import { DocumentNode } from 'graphql';
import { IDynamicReportQueryVariables } from '../../graphql/schema/p4types';

//Context object for passing of parameters relating to dynamic report generation (E.g. Alternate query/input parameters).
const DynamicReportContext = React.createContext({} as DynamicReportContextType);
export default DynamicReportContext;

type DynamicReportContextType = {
  reportQuery?: DocumentNode;
  getQueryInput?: (defaultQueryInput: IDynamicReportQueryVariables) => IDynamicReportQueryVariables;
  canonicalEntityName?: string; //Optional override for canonicalEntityName - Required for DTO reports since canonicalNames.json will not contain the type.
};
